import React from 'react';
import PickupAssign from './PickupAssign';

const PickupAssignScreen: React.FC = () => {
	return <PickupAssign parcelType='regular' title='Assign pickup riders' />;
};

export default PickupAssignScreen;
